export const COMPLAINT_STATUSES = [
  'to_submit',
  'submitted',
  'accepted',
  'rejected',
  'removed',
  'disappeared',
] as const

export type TComplaintStatus = (typeof COMPLAINT_STATUSES)[number]
